import { create } from 'zustand';

import { MeData } from 'graphQL/Auth/types';
import { STORAGE_KEY } from 'utils/localStoarge';

interface UserInformationState {
  userInfo: MeData | any;
  isLoggedIn: boolean;
  setUserInfo: (data: MeData) => void;
  clearUserInfo: () => void;
}

export const useUserInformation = create<UserInformationState>(set => ({
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo') as string)
    : {},
  isLoggedIn: localStorage.getItem(STORAGE_KEY.AUTHORIZATION) ? true : false,
  setUserInfo: (data: MeData) => {
    set({ userInfo: data, isLoggedIn: true });
    localStorage.setItem('userInfo', JSON.stringify(data));
  },
  clearUserInfo: () => {
    set({ userInfo: {}, isLoggedIn: false });
    localStorage.removeItem('userInfo');
    localStorage.removeItem(STORAGE_KEY.AUTHORIZATION);
  },
}));

// export const useUserInformation = create((set: any) => ({
//   userInfo: localStorage.getItem('userInfo')
//     ? JSON.parse(localStorage.getItem('userInfo') as string)
//     : {},
//   isLoggedIn: localStorage.getItem(STORAGE_KEY.AUTHORIZATION) ? true : false,
//   setUserInfo: (data: MeData) => {
//     set({ userInfo: data });
//     localStorage.setItem('userInfo', JSON.stringify(data));
//   },
//   clearUserInfo: () => {
//     set({ userInfo: {} });
//     localStorage.removeItem('userInfo');
//     localStorage.removeItem(STORAGE_KEY.AUTHORIZATION);
//   },
// }));
